import { getConfig } from '@zoomit/configs';

const pipeline = getConfig('PIPELINE_ENV') || 'development';
export const subDomain = pipeline === 'production' ? '' : pipeline === 'stage' ? 'stage.' : 'dev.';

/**  OriginURL for zoomit: https://zoomit.ir , for product: https://zoomit.ir , for zoomg:https://zoomg.ir and ... */
export const OriginURL = getConfig('ORIGIN_URL');

export const ApiBaseURL = getConfig('API_BASE_URL');
export const CatalogBaseApiUrl = getConfig('CATALOG_BASE_API_URL');

// Collection
export const Collection = `${ApiBaseURL}/editorial/api/article-collections`;

// Grouping
export const Grouping = `${ApiBaseURL}/editorial/api/groupings`;
export const Grouping_server = `${ApiBaseURL}/editorial/api/groupings`;

// Article
export const Article = `${ApiBaseURL}/editorial/api/articles`;
export const Article_server = `${ApiBaseURL}/editorial/api/articles`;
export const BrowseArticleAuthor = `/editorial/api/authors`;

// Accounts
export const AccountsBaseUrl = `https://accounts.${subDomain}theforge.ir`;
// base url for media preview
export const BaseMediaUrl = `${ApiBaseURL}/media`;

// Feedback
export const Topics = `${ApiBaseURL}/discussion/api/topics`;
export const Feedback = `${ApiBaseURL}/discussion/api/feedbacks`;
export const Comments = `${ApiBaseURL}/discussion/api/comments`;
export const Questions = `${ApiBaseURL}/discussion/api/questions`;
export const Answers = `${ApiBaseURL}/discussion/api/answers`;
export const Reviews = `${ApiBaseURL}/discussion/api/reviews`;
export const Discussion = `${ApiBaseURL}/discussion/api`;
export const SendEmail = `${Discussion}/contact/email/send`;

// Profile
export const Profile = `${ApiBaseURL}/profile`;
export const UserProfiles = `${ApiBaseURL}/profile/user-profiles`;
export const Bookmark = `${ApiBaseURL}/profile/bookmarks`;

// Authors
export const Authors = `${ApiBaseURL}/editorial/api/authors`;

// Notification
export const Notifier = `${ApiBaseURL}/notifier`;
export const Notification = `${Notifier}/api/notifications`;
export const UserNotifier = `${Notifier}/api/users`;

// Ads
export const Zone = `${ApiBaseURL}/ads/api/zones`;
export const Zone_server = `${ApiBaseURL}/ads/api/zones`;
export const Display = `${ApiBaseURL}/ads/api/displays`;

// Chip
export const Chip = `/forgecomposer/api/chips`;

// Module
export const Modules_server = `${ApiBaseURL}/forgecomposer/api/modules`;

// Product
export const Product = `${CatalogBaseApiUrl}/catalog/api/products`;
export const ProductNotification = `${CatalogBaseApiUrl}/catalog/api/price-alerts`;
export const PhysicalStore = `${CatalogBaseApiUrl}/catalog/api/physical-store-products`;
export const ProductSearch = `${CatalogBaseApiUrl}/catalog/api/search`;

// Product Category
export const ProductCategory = `${CatalogBaseApiUrl}/catalog/api/categories`;

// Buying Guide
export const BuyingGuide = `${CatalogBaseApiUrl}/catalog/api/buying-guides
`;

// Store link
export const StoreLink = `${CatalogBaseApiUrl}/catalog/store-links`;

// IAM
export const IAM = `${ApiBaseURL}/iam/api`;
export const Users = `${IAM}/users`;

// Article Collection
export const ArticleCollection = `${ApiBaseURL}/editorial/api/article-collections`;

// Search
export const searchV2 = `${ApiBaseURL}/editorial/api/search/v2`;

// Poll
export const Poll = `${ApiBaseURL}/discussion/api/polls`;

// Menus
export const Menus = `${ApiBaseURL}/forgecomposer/api/menus`;

//about-us
export const ABOUT_US_ORGANIZATIONS = `${ApiBaseURL}/forgecomposer/api/organizations`;

// Video
export const Video = `${BaseMediaUrl}/api/video-metadata`;

// Overlay
export const OVERLAY_BASE_URL = `${ApiBaseURL}/forgecomposer/api/overlays`;
export const OVERLAY_VISIT_COUNT = `${OVERLAY_BASE_URL}/visit`;
export const OVERLAY_CLICK_COUNT = `${OVERLAY_BASE_URL}/click`;

// Query
export const Quiz = `${ApiBaseURL}/editorial/api/quizzes`;
